import { combineLatest } from "rxjs";
import { filter, ignoreElements, tap } from "rxjs/operators";
import { logSound } from "../../../utils/logging/logging";
import { IdEventSoundCore } from "../../../utils/sound/IdEventSoundCore";
import { IdSoundGroup } from "../../../utils/sound/IdSoundGroup";
import { utilSound } from "../../../utils/sound/utilSound";
import { TypeActionScene } from "../../scenes/actionScenes";
export var epicSoundsMusic = function (action$) {
    var sceneSwap$ = action$.pipe(filter(function (action) { return action.type === TypeActionScene.Swap; }));
    var musicLoaded$ = utilSound.loaded$.pipe(filter(function (id) { return id === IdSoundGroup.Music; }), tap(function (id) { return logSound("Group loaded: " + IdSoundGroup[id]); }));
    return combineLatest(sceneSwap$, musicLoaded$).pipe(tap(function (actions) { return utilSound.eventWithParams(IdEventSoundCore.Music, actions[0].sceneId); }), ignoreElements());
};



//////////////////
// WEBPACK FOOTER
// ./src/features/sound/epics/epicSoundsMusic.ts
// module id = 2408
// module chunks = 3